// extracted by mini-css-extract-plugin
export default {"Likes":"Likes_Likes__QPBkR","LikesContainer":"Likes_LikesContainer__im3t8"};